import { AuthService, StorageService } from "../services";
import { logout } from "../services/interceptors/Interceptors";

const tokenMonitor = async (token: string, refreshToken: string) => {
  // Se token e refreshToken nao existirem, retorna null
  if (!token || !refreshToken) {
    return null;
  }

  // Verifica se o token ainda é válido
  const currentTime = Date.now();
  const tokenExp = AuthService.decodeJwt(token)?.exp * 1000;
  const refreshTokenExp = AuthService.decodeJwt(refreshToken)?.exp * 1000;

  // Se Token for válido
  if (tokenExp && tokenExp > currentTime) {
    return token;
  }

  // Se refreshToken ainda válido, renova o token
  else if (refreshTokenExp && refreshTokenExp > currentTime) {
    if (StorageService.getRefreshingToken()) {
      return;
    }
    StorageService.setRefreshingToken(true);

    try {
      const response = await AuthService.refreshToken();
      const newToken = response.data.data.token;
      const newRefreshToken = response.data.data.refreshToken;

      // Atualiza localStorage
      StorageService.setToken(newToken);
      StorageService.setRefreshToken(newRefreshToken);

      return newToken;
    } catch (error) {
      return null;
    } finally {
        StorageService.setRefreshingToken(false);
      window.location.reload();
    }
  }

  // Token e refreshToken expirados
  logout();
  return null;
};

export default tokenMonitor;
